export default {"src":"/_next/static/media/Group-26916.5c647998.svg","height":73,"width":73};